import styled from '@emotion/styled';
import { BaseButton, forPhoneOnly, Variables } from '../../base';
import { AuthorIndicator } from '../author-indicator';
import { NoteIndicator } from '../note-indicator';

interface IEntry {
    note?: boolean;
}

export const History = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
`;

export const CommentsHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 25px 24px 16px;
    border-top: 1px solid ${Variables.Colors.n15};
`;

export const CommentsHeaderTitle = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const CommentsIcon = styled.div`
    display: flex;
    align-items: center;
    color: ${Variables.Colors.n85};
`;

export const CommentsLabel = styled.div`
    font-size: 14px;
    font-weight: ${Variables.FontWeight.semibold};
    color: ${Variables.Colors.n85};
`;

export const CommentsBadge = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2px 8px;
    background-color: ${Variables.Colors.n15};
    color: ${Variables.Colors.n70};
    font-size: 12px;
    font-weight: ${Variables.FontWeight.semibold};
    border-radius: 9999px;
    min-width: 24px;
    height: 20px;
`;

export const HistoryHeader = styled.div`
    display: flex;
    align-items: center;
    padding: 16px 32px;
`;

export const HistoryHeaderLine = styled.div`
    flex-grow: 1;
    box-shadow: ${Variables.Shadows.border};
`;

export const HistoryHeaderLabel = styled.div`
    font-size: 15px;
    letter-spacing: 0.4px;
    color: ${Variables.Colors.n70};
    padding: 0 24px;
`;

export const HistoryBody = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    gap: 16px;
    padding: 0 24px;
`;

export const HistoryNoteButton = styled(BaseButton)`
    padding: 0 6px;
    min-width: unset;
    height: 20px;
`;

const noteIndicator = styled(NoteIndicator);
const EntryComment = `
    padding: 17px;
    color: ${Variables.Colors.n70};
    background-color: ${Variables.Colors.white};
    border: 1px solid ${Variables.Colors.n15};
    border-radius: ${Variables.Rounded.large};
    ${noteIndicator} {
        background-color: ${Variables.Colors.white};
        svg {
            fill: ${Variables.Colors.white};
        }
    }
`;
const EntryNote = `
    padding: 17px;
    border: 1px solid ${Variables.Colors.b100};
    border-radius: ${Variables.Rounded.large};
    background-color: ${Variables.Colors.b300_l96};
    ${noteIndicator} {
        transition: all 0s;
        background-color: ${Variables.Colors.b300_l96};
        svg {
            fill: ${Variables.Colors.b300_l96};
        }
    }
`;

export const HistoryEntry = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 2px;

    font-size: 14px;
    letter-spacing: 0.2px;

    ${(props: IEntry): string | undefined => (props.note ? EntryNote : EntryComment)}

    ${forPhoneOnly(`
        display: block;
    `)};
`;

export const HistoryAuthorIndicator = styled(AuthorIndicator)`
    margin-right: 6px;
`;

export const HistoryEntryTopic = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const HistoryEntryName = styled.div`
    font-size: 14px;
    font-weight: ${Variables.FontWeight.semibold};
    color: ${Variables.Colors.n100};
`;

export const HistoryNoteSpacer = styled.span`
    flex-grow: 1;
`;

export const HistoryEntryTime = styled.div`
    font-size: 12px;
    font-weight: ${Variables.FontWeight.regular};
    color: ${Variables.Colors.n50};
`;

export const HistoryEntryMessage = styled.div`
    display: inline-flex;
    padding: 0;
    line-height: 1.6;

    overflow-x: hidden;

    * {
        white-space: pre-wrap;
        max-width: 100%;
    }

    pre, code {
        word-wrap: break-word;
        overflow-wrap: break-word;
    }
`;

export const HistoryEntryEdited = styled.div`
    margin-left: 8px;
    color: ${Variables.Colors.n50};
`;

export const HistoryEntryAttachment = styled.div`
    padding: 8px 0;
`;

export const LoadingText = styled.div`
    font-size: 14px;
    color: ${Variables.Colors.n50};
    font-style: italic;
    padding: 8px 0;
`;
